var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m371.496 485.52c-44.136 19.864-82.392 26.48-134.624 26.48-122.112 0-229.52-87.544-229.52-231.72 0-150.072 108.872-280.28 275.136-280.28 129.472 0 222.16 89.016 222.16 212.6 0 107.4-60.32 175.08-139.768 175.08-34.576 0-59.584-17.656-63.264-56.648h-1.472c-22.8 37.52-55.904 56.648-94.896 56.648-47.816 0-82.392-35.312-82.392-95.64 0-89.744 66.208-171.4 172.136-171.4 32.368 0 69.144 8.096 87.544 18.392l-22.064 136.096c-7.352 43.392-2.208 63.264 18.392 63.992 31.632.736 71.352-39.728 71.352-124.32 0-95.632-61.792-169.936-175.824-169.936-112.544 0-211.128 88.28-211.128 228.784 0 122.848 78.712 192.736 188.328 192.736 37.52 0 77.248-8.088 106.664-23.544zm-65.472-303.816c-5.888-1.472-13.248-2.944-22.808-2.944-48.544 0-86.808 47.816-86.808 104.456 0 27.952 12.512 45.608 36.784 45.608 27.216 0 55.912-34.576 62.528-77.24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAt);
export default __webpack_public_path__ + "static/media/at.9ce6c33b3bbf8b45f0dfd83ffbc95e36.svg";
export { ForwardRef as ReactComponent };